import { HttpQueryParameter } from 'src/models/general/http.query.parameter.model';
import { Pagination, PaginationDefaults } from 'src/models/general/pagination.model';

export class ListQueryParameter extends HttpQueryParameter {
	limit!: number;
	pageSize!: number;
	page!: number;
	sortProperty?: string;
	sortDirection?: string;

	initPagination(pagination: Pagination = new PaginationDefaults()): void {
		this.setPageSize(pagination.pageSize);
		this.setPage(pagination.currentPage);
	}

	private setPage(currentPage: number): void {
		if (currentPage < 0) {
			this.page = 1;
		} else {
			this.page = currentPage + 1; // Just for BE
		}
	}

	initSort(sort: { active: string, direction: string } | undefined): void {
		if (sort) {
			this.sortProperty = sort.active;
			this.sortDirection = sort.direction;
		}
	}

	private setPageSize(pageSize: number): void {
		if (pageSize <= 0) {
			const defaults = new PaginationDefaults();
			this.pageSize = defaults.pageSize;
		} else {
			this.pageSize = pageSize;
		}
	}
}
